/**
 * The GradientType class provides values for the <code>type</code> parameter
 * in the <code>beginGradientFill()</code> and
 * <code>lineGradientStyle()</code> methods of the flash.display.Graphics
 * class.
 */
export var GradientType;
(function (GradientType) {
    /**
     * Value used to specify a linear gradient fill.
     */
    GradientType["LINEAR"] = "linear";
    /**
     * Value used to specify a radial gradient fill.
     */
    GradientType["RADIAL"] = "radial";
})(GradientType || (GradientType = {}));
